import PageDataContextService from "@core-ui/ContextServices/PageDataContext";
import { useAgentChatVisibility } from "@ext/agent/components/hooks/useAgentChatVisibility";

// ML-1106 legacy AI: text generation, prompts, prettify, mic transcription, file transcription. Hidden when the agent is available.
export const useLegacyAiAvailable = (): boolean => {
	const isAiEnabled = PageDataContextService.value?.conf?.ai?.enabled;
	const { showToggle: isAgentAvailable } = useAgentChatVisibility();

	return !!isAiEnabled && !isAgentAvailable;
};
